import { render, staticRenderFns } from "./JSelectLiuChen.vue?vue&type=template&id=2674969c&scoped=true"
import script from "./JSelectLiuChen.vue?vue&type=script&lang=js"
export * from "./JSelectLiuChen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674969c",
  null
  
)

export default component.exports